'use strict';

import React, {Component} from 'react';

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { map } from 'underscore';

import AppStore from './AppStore';
import {States} from './AppConstants';
import {IdentityProviders} from './AppConstants';
import PropTypes from "prop-types";

class AppInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        }
    }

    toggleModal = () => this.setState({ showModal: !this.state.showModal });

    render() {

        const OpenComponent = this.props.openComponent;
        let isButtonOpenComponent = OpenComponent.hasOwnProperty("displayName") && OpenComponent.displayName === "Button";

        return (
            <>
                {/* Data Attributes are here for automated testing */}
                <OpenComponent
                    id="application-details"
                    variant={isButtonOpenComponent ? "inline-link":undefined}
                    onClick={this.toggleModal}
                    data-app-version={AppStore.getApplicationVersion()}
                    data-app-build={AppStore.getChecksum()}
                    data-app-host={AppStore.getHostname()}>
                    App Info
                </OpenComponent>
                <Modal
                    id="modal-build-info"
                    show={this.state.showModal}
                    onHide={this.toggleModal}
                    size="lg"
                    aria-labelledby="modal-build-info-title"
                    centered>
                    <Modal.Header closeButton>
                        <Modal.Title id="modal-build-info-title">App Info</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <dl className="description-term-colon row">
                            <dt className="col-xs-12 col-md-3 text-truncate">Name</dt>
                            <dd className="col-xs-12 col-md-9">{AppStore.getApplicationName()}</dd>
                            <dt className="col-xs-12 col-md-3 text-truncate">Host</dt>
                            <dd className="col-xs-12 col-md-9">{AppStore.getHostname()}</dd>
                            <dt className="col-xs-12 col-md-3 text-truncate">Version</dt>
                            <dd className="col-xs-12 col-md-9">{AppStore.getApplicationVersion()}</dd>
                            <dt className="col-xs-12 col-md-3 text-truncate">Checksum</dt>
                            <dd className="col-xs-12 col-md-9">{AppStore.getChecksum()}</dd>
                            {AppStore.state === States.maintenance &&
                                <>
                                    <dt className="col-xs-12 col-md-3 text-truncate">Maintenance Login</dt>
                                    <dd className="col-xs-12 col-md-9">
                                        <ul>
                                            {map({
                                                "Netid": IdentityProviders.netId.id,
                                                "Google": IdentityProviders.google.id,
                                            }, (type, text) => (
                                                <li key={type} className="mb-2 mb-md-0">
                                                    <small>
                                                        <Button
                                                            variant="inline-link"
                                                            className="text-decoration-underline"
                                                            onClick={() => AppStore.login(type)}>
                                                            {text}
                                                        </Button>
                                                    </small>
                                                </li>
                                            ))}
                                        </ul>
                                    </dd>
                                </>
                            }
                        </dl>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

AppInfo.propTypes = {
    openComponent: PropTypes.elementType
}

AppInfo.defaultProps = {
    openComponent: Button
};

AppInfo

export default AppInfo;